import React from 'react';

export function ContractIMSInfo() {

    return (
        <>
            <div style={{
                width: '100%',
                boxSizing: 'border-box',
                backgroundColor: '#e34f5c',
                padding: '10px',
                color: 'white',
                textAlign: 'left',
            }}>
              Der Zähler am Vertrag ist ein intelligentes Messsystem.
              Die Zählerstände werden automatisch über das im Zähler verbaute Kommunikationsmodul (Smart Meter Gateway) übermittelt.
              Ein separates Melden des Zählerstands ist nicht notwendig.
            </div>
        </>
    );

}